import PropTypes from 'prop-types';

import { Button, ModalV2 as Modal } from '@utilities';

const ConfirmActionModal = ({
  confirmText,
  confirmVariant = 'primary',
  isActive,
  isCancelDisabled = false,
  isConfirmDisabled = false,
  message,
  onCancel,
  onConfirm,
  title,
}) => (
  <Modal
    buttons={[
      <Button
        isDisabled={isCancelDisabled}
        key="cancel-confirm-action"
        onClick={onCancel}
        text="Cancel"
        variant="secondary"
      />,
      <Button
        isDisabled={isConfirmDisabled}
        key="confirm-confirm-action"
        onClick={onConfirm}
        text={confirmText}
        variant={confirmVariant}
      />,
    ]}
    isActive={isActive}
    onClose={isCancelDisabled ? undefined : onCancel}
    size="small"
    title={title}
  >
    <p>{message}</p>
  </Modal>
);

ConfirmActionModal.propTypes = {
  confirmText: PropTypes.string.isRequired,
  confirmVariant: PropTypes.oneOf(['primary', 'secondary', 'error']),
  isActive: PropTypes.bool,
  isCancelDisabled: PropTypes.bool,
  isConfirmDisabled: PropTypes.bool,
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default ConfirmActionModal;
